import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import updateMeta from "@/_shared/lib/update-route-meta";

import { fullDomain } from "@/_shared/lib/meta/url-locale";
let location = window.location.href.replace(fullDomain, "");
if (location.slice(-1) !== "/") location += "/";

const urlParts = location.split("/");
let base = "/";
if (["en", "et", "fi", "ru", "lv"].includes(urlParts[0])) base += urlParts[0];
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: base,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, savedPosition) => {
  updateMeta(to, from, savedPosition);
});

export default router;
